module.exports = __webpack_public_path__ + "img/10a-analises-minhas-show.9496fd4b.png";